"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USStateDisplayNameMapping = exports.USStatesDisplayName = exports.USStatesPostal = void 0;
var USStatesPostal;
(function (USStatesPostal) {
    USStatesPostal["Alabama"] = "AL";
    USStatesPostal["Alaska"] = "AK";
    USStatesPostal["Arizona"] = "AZ";
    USStatesPostal["Arkansas"] = "AR";
    USStatesPostal["California"] = "CA";
    USStatesPostal["Colorado"] = "CO";
    USStatesPostal["Connecticut"] = "CT";
    USStatesPostal["Delaware"] = "DE";
    USStatesPostal["Florida"] = "FL";
    USStatesPostal["Georgia"] = "GA";
    USStatesPostal["Hawaii"] = "HI";
    USStatesPostal["Idaho"] = "ID";
    USStatesPostal["Illinois"] = "IL";
    USStatesPostal["Indiana"] = "IN";
    USStatesPostal["Iowa"] = "IA";
    USStatesPostal["Kansas"] = "KS";
    USStatesPostal["Kentucky"] = "KY";
    USStatesPostal["Louisiana"] = "LA";
    USStatesPostal["Maine"] = "ME";
    USStatesPostal["Maryland"] = "MD";
    USStatesPostal["Massachusetts"] = "MA";
    USStatesPostal["Michigan"] = "MI";
    USStatesPostal["Minnesota"] = "MN";
    USStatesPostal["Mississippi"] = "MS";
    USStatesPostal["Missouri"] = "MO";
    USStatesPostal["Montana"] = "MT";
    USStatesPostal["Nebraska"] = "NE";
    USStatesPostal["Nevada"] = "NV";
    USStatesPostal["NewHampshire"] = "NH";
    USStatesPostal["NewJersey"] = "NJ";
    USStatesPostal["NewMexico"] = "NM";
    USStatesPostal["NewYork"] = "NY";
    USStatesPostal["NorthCarolina"] = "NC";
    USStatesPostal["NorthDakota"] = "ND";
    USStatesPostal["Ohio"] = "OH";
    USStatesPostal["Oklahoma"] = "OK";
    USStatesPostal["Oregon"] = "OR";
    USStatesPostal["Pennsylvania"] = "PA";
    USStatesPostal["RhodeIsland"] = "RI";
    USStatesPostal["SouthCarolina"] = "SC";
    USStatesPostal["SouthDakota"] = "SD";
    USStatesPostal["Tennessee"] = "TN";
    USStatesPostal["Texas"] = "TX";
    USStatesPostal["Utah"] = "UT";
    USStatesPostal["Vermont"] = "VT";
    USStatesPostal["Virginia"] = "VA";
    USStatesPostal["Washington"] = "WA";
    USStatesPostal["WestVirginia"] = "WV";
    USStatesPostal["Wisconsin"] = "WI";
    USStatesPostal["Wyoming"] = "WY";
    USStatesPostal["DistrictOfColumbia"] = "DC";
    USStatesPostal["AmericanSamoa"] = "AS";
    USStatesPostal["FederatedStatesOfMicronesia"] = "FM";
    USStatesPostal["Guam"] = "GU";
    USStatesPostal["MilitaryAmericas"] = "AA";
    USStatesPostal["MilitaryEurope"] = "AE";
    USStatesPostal["MilitaryPacific"] = "AP";
    USStatesPostal["NorthernMarianaIslands"] = "MP";
    USStatesPostal["PuertoRico"] = "PR";
    USStatesPostal["RepublicOfPalau"] = "PW";
    USStatesPostal["USVirginIslands"] = "VI";
})(USStatesPostal || (exports.USStatesPostal = USStatesPostal = {}));
var USStatesDisplayName;
(function (USStatesDisplayName) {
    USStatesDisplayName["Alabama"] = "Alabama";
    USStatesDisplayName["Alaska"] = "Alaska";
    USStatesDisplayName["Arizona"] = "Arizona";
    USStatesDisplayName["Arkansas"] = "Arkansas";
    USStatesDisplayName["California"] = "California";
    USStatesDisplayName["Colorado"] = "Colorado";
    USStatesDisplayName["Connecticut"] = "Connecticut";
    USStatesDisplayName["Delaware"] = "Delaware";
    USStatesDisplayName["Florida"] = "Florida";
    USStatesDisplayName["Georgia"] = "Georgia";
    USStatesDisplayName["Hawaii"] = "Hawaii";
    USStatesDisplayName["Idaho"] = "Idaho";
    USStatesDisplayName["Illinois"] = "Illinois";
    USStatesDisplayName["Indiana"] = "Indiana";
    USStatesDisplayName["Iowa"] = "Iowa";
    USStatesDisplayName["Kansas"] = "Kansas";
    USStatesDisplayName["Kentucky"] = "Kentucky";
    USStatesDisplayName["Louisiana"] = "Louisiana";
    USStatesDisplayName["Maine"] = "Maine";
    USStatesDisplayName["Maryland"] = "Maryland";
    USStatesDisplayName["Massachusetts"] = "Massachusetts";
    USStatesDisplayName["Michigan"] = "Michigan";
    USStatesDisplayName["Minnesota"] = "Minnesota";
    USStatesDisplayName["Mississippi"] = "Mississippi";
    USStatesDisplayName["Missouri"] = "Missouri";
    USStatesDisplayName["Montana"] = "Montana";
    USStatesDisplayName["Nebraska"] = "Nebraska";
    USStatesDisplayName["Nevada"] = "Nevada";
    USStatesDisplayName["NewHampshire"] = "New Hampshire";
    USStatesDisplayName["NewJersey"] = "New Jersey";
    USStatesDisplayName["NewMexico"] = "New Mexico";
    USStatesDisplayName["NewYork"] = "New York";
    USStatesDisplayName["NorthCarolina"] = "North Carolina";
    USStatesDisplayName["NorthDakota"] = "North Dakota";
    USStatesDisplayName["Ohio"] = "Ohio";
    USStatesDisplayName["Oklahoma"] = "Oklahoma";
    USStatesDisplayName["Oregon"] = "Oregon";
    USStatesDisplayName["Pennsylvania"] = "Pennsylvania";
    USStatesDisplayName["RhodeIsland"] = "Rhode Island";
    USStatesDisplayName["SouthCarolina"] = "South Carolina";
    USStatesDisplayName["SouthDakota"] = "South Dakota";
    USStatesDisplayName["Tennessee"] = "Tennessee";
    USStatesDisplayName["Texas"] = "Texas";
    USStatesDisplayName["Utah"] = "Utah";
    USStatesDisplayName["Vermont"] = "Vermont";
    USStatesDisplayName["Virginia"] = "Virginia";
    USStatesDisplayName["Washington"] = "Washington";
    USStatesDisplayName["WestVirginia"] = "West Virginia";
    USStatesDisplayName["Wisconsin"] = "Wisconsin";
    USStatesDisplayName["Wyoming"] = "Wyoming";
    USStatesDisplayName["DistrictOfColumbia"] = "District of Columbia";
    USStatesDisplayName["AmericanSamoa"] = "American Samoa";
    USStatesDisplayName["FederatedStatesOfMicronesia"] = "Federated States of Micronesia";
    USStatesDisplayName["Guam"] = "Guam";
    USStatesDisplayName["MilitaryAmericas"] = "Military - Americas";
    USStatesDisplayName["MilitaryEurope"] = "Military - Europe";
    USStatesDisplayName["MilitaryPacific"] = "Military - Pacific";
    USStatesDisplayName["NorthernMarianaIslands"] = "Northern Mariana Islands";
    USStatesDisplayName["PuertoRico"] = "Puerto Rico";
    USStatesDisplayName["RepublicOfPalau"] = "Republic of Palau";
    USStatesDisplayName["USVirginIslands"] = "Virgin Islands, U.S.";
})(USStatesDisplayName || (exports.USStatesDisplayName = USStatesDisplayName = {}));
exports.USStateDisplayNameMapping = {
    [USStatesPostal.Alabama]: USStatesDisplayName.Alabama,
    [USStatesPostal.Alaska]: USStatesDisplayName.Alaska,
    [USStatesPostal.Arizona]: USStatesDisplayName.Arizona,
    [USStatesPostal.Arkansas]: USStatesDisplayName.Arkansas,
    [USStatesPostal.California]: USStatesDisplayName.California,
    [USStatesPostal.Colorado]: USStatesDisplayName.Colorado,
    [USStatesPostal.Connecticut]: USStatesDisplayName.Connecticut,
    [USStatesPostal.Delaware]: USStatesDisplayName.Delaware,
    [USStatesPostal.Florida]: USStatesDisplayName.Florida,
    [USStatesPostal.Georgia]: USStatesDisplayName.Georgia,
    [USStatesPostal.Hawaii]: USStatesDisplayName.Hawaii,
    [USStatesPostal.Idaho]: USStatesDisplayName.Idaho,
    [USStatesPostal.Illinois]: USStatesDisplayName.Illinois,
    [USStatesPostal.Indiana]: USStatesDisplayName.Indiana,
    [USStatesPostal.Iowa]: USStatesDisplayName.Iowa,
    [USStatesPostal.Kansas]: USStatesDisplayName.Kansas,
    [USStatesPostal.Kentucky]: USStatesDisplayName.Kentucky,
    [USStatesPostal.Louisiana]: USStatesDisplayName.Louisiana,
    [USStatesPostal.Maine]: USStatesDisplayName.Maine,
    [USStatesPostal.Maryland]: USStatesDisplayName.Maryland,
    [USStatesPostal.Massachusetts]: USStatesDisplayName.Massachusetts,
    [USStatesPostal.Michigan]: USStatesDisplayName.Michigan,
    [USStatesPostal.Minnesota]: USStatesDisplayName.Minnesota,
    [USStatesPostal.Mississippi]: USStatesDisplayName.Mississippi,
    [USStatesPostal.Missouri]: USStatesDisplayName.Missouri,
    [USStatesPostal.Montana]: USStatesDisplayName.Montana,
    [USStatesPostal.Nebraska]: USStatesDisplayName.Nebraska,
    [USStatesPostal.Nevada]: USStatesDisplayName.Nevada,
    [USStatesPostal.NewHampshire]: USStatesDisplayName.NewHampshire,
    [USStatesPostal.NewJersey]: USStatesDisplayName.NewJersey,
    [USStatesPostal.NewMexico]: USStatesDisplayName.NewMexico,
    [USStatesPostal.NewYork]: USStatesDisplayName.NewYork,
    [USStatesPostal.NorthCarolina]: USStatesDisplayName.NorthCarolina,
    [USStatesPostal.NorthDakota]: USStatesDisplayName.NorthDakota,
    [USStatesPostal.Ohio]: USStatesDisplayName.Ohio,
    [USStatesPostal.Oklahoma]: USStatesDisplayName.Oklahoma,
    [USStatesPostal.Oregon]: USStatesDisplayName.Oregon,
    [USStatesPostal.Pennsylvania]: USStatesDisplayName.Pennsylvania,
    [USStatesPostal.RhodeIsland]: USStatesDisplayName.RhodeIsland,
    [USStatesPostal.SouthCarolina]: USStatesDisplayName.SouthCarolina,
    [USStatesPostal.SouthDakota]: USStatesDisplayName.SouthDakota,
    [USStatesPostal.Tennessee]: USStatesDisplayName.Tennessee,
    [USStatesPostal.Texas]: USStatesDisplayName.Texas,
    [USStatesPostal.Utah]: USStatesDisplayName.Utah,
    [USStatesPostal.Vermont]: USStatesDisplayName.Vermont,
    [USStatesPostal.Virginia]: USStatesDisplayName.Virginia,
    [USStatesPostal.Washington]: USStatesDisplayName.Washington,
    [USStatesPostal.WestVirginia]: USStatesDisplayName.WestVirginia,
    [USStatesPostal.Wisconsin]: USStatesDisplayName.Wisconsin,
    [USStatesPostal.Wyoming]: USStatesDisplayName.Wyoming,
    [USStatesPostal.DistrictOfColumbia]: USStatesDisplayName.DistrictOfColumbia,
    [USStatesPostal.AmericanSamoa]: USStatesDisplayName.AmericanSamoa,
    [USStatesPostal.FederatedStatesOfMicronesia]: USStatesDisplayName.FederatedStatesOfMicronesia,
    [USStatesPostal.Guam]: USStatesDisplayName.Guam,
    [USStatesPostal.MilitaryAmericas]: USStatesDisplayName.MilitaryAmericas,
    [USStatesPostal.MilitaryEurope]: USStatesDisplayName.MilitaryEurope,
    [USStatesPostal.MilitaryPacific]: USStatesDisplayName.MilitaryPacific,
    [USStatesPostal.NorthernMarianaIslands]: USStatesDisplayName.NorthernMarianaIslands,
    [USStatesPostal.PuertoRico]: USStatesDisplayName.PuertoRico,
    [USStatesPostal.RepublicOfPalau]: USStatesDisplayName.RepublicOfPalau,
    [USStatesPostal.USVirginIslands]: USStatesDisplayName.USVirginIslands,
};
//# sourceMappingURL=states.js.map